import moment from 'moment';

import { FIELD_PATHS } from '@funnels/constants';
import { EmploymentEntityIndex } from '@funnels/types';
import { validateDateString } from '@funnels/utils';

import { DatePickerInputField } from '../../Fields';

interface ReturnToWorkDateProps extends EmploymentEntityIndex {
  isDisabled?: boolean;
  isOptional?: boolean;
}

const validate = (value: string) =>
  validateDateString()(value) || moment(value) <= moment() ? 'Please enter a return date after this month' : undefined;

export const ReturnToWorkDate = (props: ReturnToWorkDateProps) => {
  const { employmentIndex, ...rest } = props;

  return (
    <DatePickerInputField
      {...rest}
      name={FIELD_PATHS.EMPLOYMENT_MATERNITY_LEAVE_RETURN_DATE(employmentIndex)}
      label="Return to work date"
      validate={validate}
    />
  );
};
